import styled from 'styled-components'

import ArticleBlock from '../ArticleBlock'

export const ArticleRecipesBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 2rem;
`

export const Article = styled(ArticleBlock)``
